module.exports = __webpack_public_path__ + "static/media/envelope.573d85fc.svg";